import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { EXTERNAL_CONNECTION_ACCOUNT } from './schema';

const MUTATION = gql`
  mutation ExternalConnectionDisconnect(
    $customerId: ID!
    $dataSource: PerformanceCenterDataSource!
    $accountId: String!
  ) {
    externalConnectionDisconnect(
      customerId: $customerId
      dataSource: $dataSource
      accountId: $accountId
    ) {
      ...ExternalConnectionAccount
    }
  }
  ${EXTERNAL_CONNECTION_ACCOUNT}
`;

export const externalConnectionDisconnect = async ({ customerId, dataSource, accountId }) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, dataSource, accountId },
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp(result.data);
};
